// Layout.tsx
import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';
import FeedbackButton from './FeedbackButton';
import styles from './Layout.module.css';
import logo from '../assets/Icons/NEWTFICLOGO_no_bg.png';
import { FaUser } from 'react-icons/fa';
import { Search, Command } from 'lucide-react';
import defaultAvatar from '../assets/DefaultIcon.png';

interface LayoutProps {
  children?: ReactNode;
  onOpenQuickActions?: () => void;
}
const resolveAvatarUrl = (url?: string) =>
  url?.startsWith('http') ? url : `${process.env.REACT_APP_API_URL}${url}`;

const Layout: React.FC<LayoutProps> = ({ children, onOpenQuickActions }) => {
  const { user, logout } = useAuth();

  return (
    <div className={styles.layoutContainer}>
      <Sidebar />
      
      <div className={styles.mainContainer}>
        <header className={styles.header}>
          <div className={styles.headerCenter}>
            <div className={styles.brandText}>
              <h1 className={styles.brandName}>The Frontier Initiative Corporation</h1>
              <p className={styles.tagline}>Explore the Frontier. Build the Future.</p>
            </div>
          </div>

          <nav className={styles.navbarRight}>
            {user ? (
              <>
                {/* Quick Actions Button */}
                <button 
                  className={styles.quickActionsButton}
                  onClick={onOpenQuickActions}
                  title="Quick Actions"
                >
                  <Search size={18} />
                  <span className={styles.quickActionsText}>Quick Actions</span>
                  <span className={styles.quickActionsShortcut}>
                    <Command size={12} />
                    <span>K</span>
                  </span>
                </button>

                <img
                  src={user?.avatarUrl ? resolveAvatarUrl(user.avatarUrl) : defaultAvatar}
                  alt="User Avatar"
                  className={styles.navAvatar}
                />
                <button className={styles.navButton} onClick={logout}>
                  <FaUser style={{ marginRight: '6px' }} />
                  Logout
                </button>
              </>
            ) : (
              <>
              <img
                src={defaultAvatar}
                alt="Default Avatar"
                className={styles.navAvatar}
              />
              <div className={styles.authButtonGroup}>
                <Link to="/login" className={styles.navButton}>
                  <FaUser style={{ marginRight: '6px' }} />
                  Login
                </Link>
                <Link to="/register" className={styles.navButton}>
                  <FaUser style={{ marginRight: '6px' }} />
                  Register
                </Link>
              </div>
            </>
            )}
          </nav>
        </header>

        <main className={styles.mainContent}>
          {children}
        </main>

        {/* Floating Feedback Button */}
        {user && <FeedbackButton />}

        <footer className={styles.footer}>
          <div className={styles.footerContent}>
            <p>© {new Date().getFullYear()} The Frontier Initiative Corporation</p>
            <div className={styles.footerLinks}>
              <a href="https://discord.gg/HMcSRn8ZKc" target="_blank" rel="noopener noreferrer">Join Discord</a>
              <Link to="/changelog" className={styles.footerLink}>Changelog</Link>
              <a href="https://ko-fi.com/digitalhorizonlabs" target="_blank" rel="noopener noreferrer" style={{ color: '#ff5e5b' }}>☕ Support Us</a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Layout;
